module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_cof.70762362.png";